import { memo, useEffect, useMemo, useState } from 'react';
import LoginQR from './LoginQR';
import { Container, Row, Col, NavDropdown } from 'react-bootstrap';
import { BzTabsContainer, BzTabsContent, BzInputText, BzButton } from '../../components';
import { useSelector } from 'react-redux';
//PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
import { API_ERRORS, API_RESPONSE_STATUS, APP_INFO_PARAMS, LOCAL_STORAGE_KEYS, LOGIN_CONSTANTS, LOGIN_ERROR_MSG } from '../../utils/global_variables';
import { getAppInfoData, handleKeyDownOnDiv } from '../../utils/global_functions';
//PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End


const FormBody = ({ loginTab, text, showErrorBorder, spinner, objUserCredentials, showPassword, setShowPassword, route, handleSignup, handleTakeMeToSelect, bLoginButton, handleUserIdPasswordOnChange, objLoginSession, handleLogin, handleMpinPassword, handleShow, handleForgotUserId }) => {

  const brokerInformation = useSelector(state => state?.appInfo?.brokerInformation);
  const appInfo = useSelector(state => state.appInfo.appInfo);
  // BT-95890 -Mahesh S -  first time user login - code added for auth service down - start
  const authServiceDown = useSelector(state => state?.auth?.authServiceDown);
  // BT-95890 -Mahesh S -  first time user login - code added for auth service down - end

  const [eKYCInfo, setEKYCInfo] = useState(null);
  const [eKYCText, setEKYCText] = useState('');

  //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
  const nGuestTrialDays = useMemo(() => {
    return getAppInfoData(APP_INFO_PARAMS.APP_GUEST_MODE_TRIAL_DAYS, appInfo);
  }, [appInfo]);
  //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End

  useEffect(() => {
    if (appInfo?.length) {
      const data = getAppInfoData(APP_INFO_PARAMS.APP_EKYC_INFO, appInfo);
      if (objLoginSession?.errors === API_ERRORS.ECODE_ACC_SUSPENDED) {
        if (data?.reekycurl && data?.ekyctext) {
          setEKYCInfo(data);
        }
        else { setEKYCInfo(null); }
        if (data?.ekyctext) {
          setEKYCText(data?.ekyctext);
        } else { setEKYCText(''); }
      }
      else {
        if (data?.ekycurl && data?.ekyctext) {
          setEKYCInfo(data);
        }
        else { setEKYCInfo(null); }
        if (data?.ekyctext) {
          setEKYCText(data?.ekyctext);
        } else { setEKYCText(''); }
      }
    }
  }, [appInfo, objLoginSession]);
  // {/* Mahesh S : 27-11-2023 : BT-95890 first time login – to show guest flag  – Start */ }
  const isGuestAllowed = getAppInfoData(APP_INFO_PARAMS.APP_GUEST_MODE, appInfo);
  const nCMOTMode = getAppInfoData(APP_INFO_PARAMS.APP_CMOT_MODE, appInfo);
  const [isGuestFlagExist, setIsGuestFlagExist] = useState(false);
  useEffect(() => {
    if (nCMOTMode === 2 && isGuestAllowed !== undefined && isGuestAllowed.toString().trim().toUpperCase() === "TRUE") {
      setIsGuestFlagExist(true);
    }
  }, [nCMOTMode, isGuestAllowed]);
  {/* Mahesh S : 27-11-2023 : BT-95890 first time login – to show guest flag  – End */ }

  useEffect(() => {
    if (localStorage.getItem(LOCAL_STORAGE_KEYS.GUEST_USER) !== undefined) {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.GUEST_USER);
    }
  }, []);



  const handleBlur = (e) => {
    if (e.target.value !== undefined && e.target.value !== null && e.target.value !== '') {
      localStorage.setItem("ACTIVE_USER", e.target.value.toUpperCase());
    }
  };

  return (
    <>
      <Container fluid className='p-0'>
        <BzTabsContainer>
          <BzTabsContent isActive={loginTab == 'user_id'} showDefault tabKey='user_id'>
            <div className='login-content p-1'>
              <form autoComplete='off' onSubmit={(e) => e.preventDefault()}>
                <Row className='g-0 mb-2'>
                  <Col>
                    <div className={`input-group ${objLoginSession?.errors === API_ERRORS.ECODE_REQ_BODY_VALIDATIONS ? 'error' : ''}`}>
                      <BzInputText data-testid='user-id' autoComplete='off' name='user_id' value={objUserCredentials.user_id ? objUserCredentials.user_id : ''} type='text' maxLength={LOGIN_CONSTANTS.LOGIN_USERID_LENGTH} placeholder='User ID' onChange={(e) => handleUserIdPasswordOnChange(e)} disabled={spinner} className={`p-0' autoFocus ${objUserCredentials.user_id ? 'text-uppercase' : ''}`} autoFocus onBlur={handleBlur} />
                    </div>
                    {text ?
                      <div className='default-msg'>We have retrieved above user ID under your name</div>
                      : null
                    }
                  </Col>
                </Row>

                <Row className='g-0 mb-2'>
                  <Col>
                    <div className={`input-group position-relative ${showErrorBorder ? 'error' : ''}  `}>
                      <BzInputText data-testid='user-password' autoComplete='off' name='user_password' value={objUserCredentials.user_password ? objUserCredentials.user_password : ''} type={`${showPassword ? 'text' : 'password'}`} placeholder='Password' maxLength={LOGIN_CONSTANTS.LOGIN_PASSWORD_MAX_LENGTH} onChange={(e) => handleUserIdPasswordOnChange(e)} disabled={spinner} className='pe-5' />
                      <div onClick={() => { setShowPassword(curr => !curr); }} className={`icon-20 ${showPassword ? 'icon-eye' : 'icon-eyeslash'} icon-grey login-icon-position`} data-testid="eye-button"></div>
                    </div>
                  </Col>
                </Row>

                {authServiceDown ?
                  <Row className='g-0 mb-2'>
                    <Col>
                      <div data-testid={"is-auth-down"} className='error-msg'>{LOGIN_ERROR_MSG.AUTH_SERVICE_DOWN}</div>
                    </Col>
                  </Row>
                  : null
                }
                {(objLoginSession && objLoginSession?.status === API_RESPONSE_STATUS.ERROR && objLoginSession?.errors !== API_ERRORS.ECODE_PWD_EXPIRED && !authServiceDown) &&
                  <Row className='g-0 mb-2'>
                    <Col>
                      <div className='error-msg'>{objLoginSession?.errors === API_ERRORS.ECODE_REQ_BODY_VALIDATIONS ? 'Incorrect User Id or Password.' : objLoginSession.message}</div>
                    </Col>
                  </Row>
                }
                {(objLoginSession?.code === API_ERRORS.ECODE_NETWORK_ERROR) &&
                  <Row className='g-0 mb-2'>
                    <Col>
                      <div className='error-msg'>{LOGIN_ERROR_MSG.NETWORK_ERROR}</div>
                    </Col>
                  </Row>
                }
                <Row className='g-0 mb-3'>
                  <Col>
                    <div className='font-regular font-size3 color-subtext float-start'>Take Me To</div>
                    <NavDropdown className='font-medium font-size3 color-primary text-capitalize ms-2 float-start' title={route} onSelect={handleTakeMeToSelect}>
                      <NavDropdown.Item size="sm" eventKey="dashboard">Dashboard</NavDropdown.Item>
                      <NavDropdown.Item size="sm" eventKey="watchlist">Watchlist</NavDropdown.Item>
                      <NavDropdown.Item size="sm" eventKey="portfolio">Portfolio</NavDropdown.Item>
                      <NavDropdown.Item size="sm" eventKey="orders">Orders</NavDropdown.Item>
                    </NavDropdown>
                  </Col>
                </Row>
                <Row className='g-0 mb-3'>
                  <Col>
                    <BzButton onClick={handleLogin} className='btn btn-md btn-block btn-primary' type='submit' disabled={!bLoginButton}>Verify</BzButton>
                  </Col>
                </Row>
              </form>

              <Row className='g-0 mb-4'>
                <Col className='d-flex justify-content-start align-self-center'>
                  <a className='font-medium font-size2 color-link focus' disabled={spinner} href='#' onKeyDown={handleKeyDownOnDiv} onClick={handleForgotUserId}>Forgot User ID?</a>
                </Col>
                <Col className='d-flex justify-content-end align-self-center'>
                  <a className='font-medium font-size2 color-link focus' disabled={spinner} href='#' onKeyDown={handleKeyDownOnDiv} onClick={() => handleMpinPassword('password')}>Forgot password?</a>
                </Col>
              </Row>

              {isGuestFlagExist ?
                <>
                  <div className='signup-box'>
                    <Row className='g-0 mb-2'>
                      <Col className='d-flex justify-content-start'>
                        <div className='font-medium font-size4 signup-box-title'>Amazing benefits with new account</div>
                      </Col>
                    </Row>
                    <Row className='g-0 mb-2'>
                      <Col className='d-flex justify-content-start'>
                        <div className='font-regular font-size2 signup-box-subtitle text-wrap'>Get free account opening, trade ideas, dedicated relationship manager &amp; margin benefit!</div>
                      </Col>
                    </Row>
                    <Row className='g-0'>
                      <Col className='d-grid'>
                        <BzButton className='btn btn-md signup-box-btn'>
                          <div className='d-flex justify-content-center align-items-center' disabled={spinner} onClick={handleSignup}>
                            <span className='font-medium font-size3 textcolor-signupbox'>Open an Account</span>
                            <div className='icon-16 icon-forward-arrow iconcolor-signupbox ms-2'></div>
                          </div>
                        </BzButton>
                      </Col>
                    </Row>
                  </div>
                  <Row className='g-0 my-3'>
                    <Col>
                      <div className='fancyline'>
                        <span className='font-medium font-size1 color-subtext'>OR</span>
                      </div>
                    </Col>
                  </Row>
                </>


                // <div className='signup-box'>
                //   <Row className='g-0'>
                //     <Col md={7} className='d-flex justify-content-start align-self-start'>
                //       <div className='font-regular font-size4 color-active-text text-wrap'>
                //         Sign up with your mobile no. &amp; start {nGuestTrialDays} day(s) free trial now
                //       </div>
                //     </Col>
                //     <Col md={5} className='d-flex justify-content-end align-self-center'>
                //       <BzButton className='btn btn-md signup-box-btn d-flex align-items-center' disabled={spinner} onClick={handleSignup}>
                //         <span className='font-medium font-size3 textcolor-signupbox'>Sign up</span>
                //         <div className='icon-16 icon-forward-arrow iconcolor-signupbox ms-2'></div>
                //       </BzButton>
                //     </Col>
                //   </Row>
                // </div>

                : null}

              {eKYCInfo ?
                <Row className='g-0 mb-2'>
                  <Col className='d-flex justify-content-start align-self-center'>
                    <div data-testid='ekycinfo' className='font-regular font-size2 color-subtext'>{eKYCInfo?.ekyctext}
                      <a data-testid='ekycinfo-link' href={`${objLoginSession?.errors === API_ERRORS.ECODE_ACC_SUSPENDED ? eKYCInfo?.reekycurl : eKYCInfo?.ekycurl}`} rel="noreferrer" target='_blank' className='font-medium font-size2 focus ms-1' disabled={spinner}>Register for free {nGuestTrialDays} days trial</a>
                    </div>
                  </Col>
                </Row>
                :
                <Row className='g-0 mb-2'>
                  <Col className='d-flex justify-content-start align-self-center'>
                    <div data-testid="no-ekycinfo" className='font-regular font-size2 color-subtext'>{(eKYCText !== '') ? eKYCText : "Try out the trading platform"}<a data-testid='no-ekycinfo-link' onClick={handleShow} onKeyDown={handleKeyDownOnDiv} className='font-medium font-size2 ms-1 focus' disabled={spinner}>Register for free {nGuestTrialDays} days trial</a></div>
                  </Col>
                </Row>
              }

            </div>
            {/* <Row className='g-0 mt-3 ps-1'>
              <Col>
                <div className='font-medium font-size1 color-subtext'>
                  {brokerInformation?.length ?
                    Object.entries(brokerInformation[0]).map(([key, item], i) => (
                      <span key={i}>
                        { item.Exchange} - <span className="font-regular">Member ID: {item.MemberID}, SEBI REG NO.: {item?.ID}</span> |
                      </span>
                    ))
                    :null
                  }
                </div>
              </Col>
            </Row> */}
          </BzTabsContent>
          <BzTabsContent isActive={loginTab == 'qr_code'} tabKey='qr_code' >
            {loginTab == 'qr_code' ? <LoginQR /> : null}
          </BzTabsContent>
        </BzTabsContainer>
      </Container>
    </>
  );
};
export default memo(FormBody);